module.exports = __webpack_public_path__ + "media/images/icons/outlined/copy-760ac6c61995031d395cf2ecd1b2bfa7.svg";